//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../Features/Features.Subdivision.SelectCageObjectData.js";
import "../GeometricUtilities/GeometricUtilities.TransformerData.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CylinderCircularSegments",1,0],[0,"CylinderLinearSegments",1,0],[1,"Height",0,"Expression",0],[1,"HeightZ",0,"Expression",0],[1,"InnerSize",0,"Expression",0],[1,"LengthX",0,"Expression",0],[1,"MeshBodies",0,"SelectNXObjectList",0],[0,"Origin",1,"Point",0],[1,"OuterSize",0,"Expression",0],[1,"PathObject",0,"Features.Subdivision.SelectCageObjectData",0],[1,"Size",0,"Expression",0],[0,"TorusCircularSegments",1,0],[0,"TorusRadialSegments",1,0],[1,"Transformer",0,"GeometricUtilities.TransformerData",0],[0,"TubeSegments",1,0],[1,"TubeSize",0,"Expression",0],[0,"Type",1,0],[1,"WidthY",0,"Expression",0],[0,"XSegments",1,0],[0,"YSegments",1,0],[0,"ZSegments",1,0]],[[[],"UpdateMesh",{},0,0]],[]];
SPLM.Features.MorphMeshCageBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.MorphMeshCageBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.MorphMeshCageBuilder.Types = Object.freeze({
    "WrapBody" : "WrapBody", "Block" : "Block", "Cylinder" : "Cylinder", "Tube" : "Tube", "Torus" : "Torus"});

export default SPLM;